import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import QRCode from 'qrcode';
import { FiDownload, FiShare2 } from 'react-icons/fi';

const QRCodePage = () => {
  const { business } = useAuth();
  const { showToast } = useToast();
  const canvasRef = useRef(null);
  const [qrDataUrl, setQrDataUrl] = useState('');

  const publicPageUrl = business ? `${window.location.origin}/business/${business.slug}` : '';

  useEffect(() => {
    if (business && publicPageUrl) {
      QRCode.toDataURL(publicPageUrl, { width: 340, margin: 2 }, (err, url) => {
        if (!err) {
          setQrDataUrl(url);
        }
      });

      if (canvasRef.current) {
        QRCode.toCanvas(canvasRef.current, publicPageUrl, { width: 280, margin: 2 }, (err) => {
          if (err) console.error(err);
        });
      }
    }
  }, [business, publicPageUrl]);

  const handleDownload = () => {
    if (!qrDataUrl) return;
    const link = document.createElement('a');
    link.href = qrDataUrl;
    link.download = `${business.slug}-qrcode.png`;
    link.click();
    showToast('High-resolution QR Code downloaded successfully!', 'success');
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `${business?.businessName} QR Code`,
        url: publicPageUrl
      }).catch(() => {});
    } else {
      navigator.clipboard.writeText(publicPageUrl);
      showToast('Business URL copied to clipboard!', 'info');
    }
  };

  if (!business) return null;

  return (
    <div style={{ maxWidth: '650px', margin: '0 auto', textAlign: 'center' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.85rem', fontWeight: 800 }}>
          Storefront QR Code Generator
        </h1>
        <p style={{ color: '#94A3B8', fontSize: '0.95rem' }}>
          Display this QR code at your store counter, product packaging, or business cards so customers scan to browse your catalogue online.
        </p>
      </div>

      <div className="glass-card" style={{ padding: '2.5rem 2rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.3rem', fontWeight: '800', marginBottom: '0.25rem', color: '#fff' }}>
          {business.businessName}
        </h3>
        <span style={{ fontSize: '0.85rem', color: 'var(--secondary-500)', fontWeight: '600', marginBottom: '1.5rem' }}>
          SCAN ME TO VIEW DIGITAL CATALOGUE
        </span>

        <div style={{
          background: '#ffffff',
          padding: '1.5rem',
          borderRadius: '24px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
          border: '4px solid var(--primary-500)',
          marginBottom: '1.5rem'
        }}>
          <canvas ref={canvasRef} />
        </div>

        <p style={{ color: '#94A3B8', fontSize: '0.9rem', marginBottom: '1.75rem', maxWidth: '420px' }}>
          Scan using any Smartphone Camera or WhatsApp Scanner to access <strong>/business/{business.slug}</strong>
        </p>

        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
          <button onClick={handleDownload} className="btn btn-primary btn-lg">
            <FiDownload /> Download High-Res PNG
          </button>
          <button onClick={handleShare} className="btn btn-secondary btn-lg">
            <FiShare2 /> Share Business Link
          </button>
        </div>
      </div>
    </div>
  );
};

export default QRCodePage;
